import { useState } from "react";
import { AuthFormValidator } from "../../utils/AuthFormValidator";
import { LoadingButton } from "../LoadingButton";

export function SignInForm({
  toggleBetweenSignUpAndSignIn,
  handleSignInResponse,
  signIn,
}) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [form, setForm] = useState({
    username: "",
    password: "",
  });
  const [errors, setErrors] = useState({});

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = AuthFormValidator.validateSignInForm(form);
    setErrors(validationErrors);
    if (Object.keys(validationErrors).length === 0) {
      const signInForm = {
        username: form.username,
        password: form.password,
        rememberMe,
      };

      const signInAttempt = await signIn(signInForm);
      if (signInAttempt) {
        setErrors(signInAttempt);
      }
      handleSignInResponse(signInAttempt);
    }
  };

  const getUsernameFromTextInput = (e) => {
    const input = e.target.value;
    setUsername(input);
    setForm({ ...form, username: input });
  };

  const getPasswordFromTextInput = (e) => {
    const input = e.target.value;
    setPassword(input);
    setForm({ ...form, password: input });
  };

  const isFormValid = username.trim() !== "" && password.trim() !== "";

  return (
    <form onSubmit={handleSubmit} className="w-full max-w-md space-y-6">
      <div className="space-y-2">
        <h2 className="text-3xl font-semibold text-gray-900">Sign In</h2>
        <p className="text-sm text-gray-600">Welcome back, lets get cooking!</p>
      </div>

      <div className="space-y-4">
        <div className="space-y-2">
          <label className="text-sm font-medium text-gray-700">Username</label>
          <input
            type="text"
            placeholder="Enter your username"
            value={username}
            onChange={getUsernameFromTextInput}
            autoComplete="on"
            className="w-full px-4 py-3 border border-gray-200 rounded-lg text-base focus:outline-none focus:ring-2 focus:ring-gray-900 focus:border-transparent"
          />
          {errors.username && (
            <p className="text-xs text-red-600">{errors.username}</p>
          )}
        </div>

        <div className="space-y-2">
          <label className="text-sm font-medium text-gray-700">Password</label>
          <input
            type="password"
            placeholder="Enter your password"
            value={password}
            onChange={getPasswordFromTextInput}
            autoComplete="on"
            className="w-full px-4 py-3 border border-gray-200 rounded-lg text-base focus:outline-none focus:ring-2 focus:ring-gray-900 focus:border-transparent"
          />
          {errors.password && (
            <p className="text-xs text-red-600">{errors.password}</p>
          )}
        </div>
      </div>

      <div className="flex items-center gap-2">
        <input
          type="checkbox"
          id="rememberMe"
          checked={rememberMe}
          onChange={(e) => setRememberMe(e.target.checked)}
          className="w-4 h-4 accent-gray-900 cursor-pointer"
        />
        <label htmlFor="rememberMe" className="text-sm text-gray-600 cursor-pointer select-none">
          Remember me
        </label>
      </div>

      {errors.general && (
        <p className="text-sm text-red-600">{errors.general}</p>
      )}

      <LoadingButton
        type="submit"
        label="Sign In"
        style={`w-full px-4 py-3 rounded-lg text-base font-medium transition-colors
          ${
            isFormValid
              ? "bg-gray-900 text-white hover:bg-gray-800"
              : "bg-gray-300 text-gray-500 cursor-not-allowed"
          }`}
        disabled={!isFormValid}
        onClick={handleSubmit}
        className="bg-gray-900 text-white hover:bg-gray-800"
      />

      <div className="text-center">
        <button
          type="button"
          onClick={toggleBetweenSignUpAndSignIn}
          className="text-sm text-gray-600 hover:text-gray-900 transition-colors"
        >
          Don't have an account? <span className="font-medium">Sign up!</span>
        </button>
      </div>
    </form>
  );
}
